export default __webpack_public_path__ + "static/media/ic-part-test.6102d7b5.svg";